import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ContractService } from '../../../_services';
import { ContractIfrsBase } from "./base/contract-ifrs.base";
import { IContract, IStore, IIdName, IIdNameGeneric } from '../../../_entities';
import { StringTool } from "../../../core/tools/index";
import * as moment from 'moment';

@Component({
	selector: 'g-costs-with-own-index',
	template: require('./g-costs-with-own-index.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class CostsWithOwnIndex extends ContractIfrsBase implements OnInit {

	constructor(contractService: ContractService) { super(contractService); }

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/g-costs-with-own-index.component.ts